// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 68,
        /* Optional */
        // loadProductFirst: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div class="grid__item grid-product small--one-half medium-up--one-quarter grid-product__has-quick-shop" data-aos="row-of-4">' +
        '<div class="grid-product__content">' +
            '{{customLabelHtml}}' +
            '{{soldOutHtml}}' +
            '{{onSaleHtml}}' +
            '{{customBadgeHtml}}' +
            '{{productLinkOpeningHtml}}' +
            '<div class="grid-product__image-mask">' +
                '<img class="grid-product__image lazyloaded" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                '<div class="grid-product__meta">' +
                    '{{vendorHtml}}' +
                    '{{titleHtml}}' +
                    '<div class="grid-product__price">' +
                        '{{priceHtml}}' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"/></svg></a></li>',
    'previousDisabledHtml': '<li class="disabled"><span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"/></svg></span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg></a></li>',
    'nextDisabledHtml': '<li class="disabled"><span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg></span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select" class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select" class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
    // if(!data.available) { return ''; }
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    var hasBadge = false,
        customBadge = '';
    var hasCustomLabel = false,
        customLabel = '';
    var tagsLength = data.tags.length;
    for (var i = 0; i < tagsLength; i++) {
        var tag = data.tags[i];
        if (tag.indexOf('_label_') >= 0) {
            hasCustomLabel = true;
            customLabel = tag.replace('_label_', '');
        }
        if (tag.indexOf('_badge-') >= 0) {
            hasBadge = true;
            customBadge = tag.replace('_badge-', '');
        }
    }

    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Custom Label
    var customLabelHtml = hasCustomLabel ? '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>' : '';
    itemHtml = itemHtml.replace(/{{customLabelHtml}}/g, customLabelHtml);

    // Add Sold Out Tag
    var soldOutHtml = soldOut ? '<div class="grid-product__tag grid-product__tag--sold-out">' + bcSfFilterConfig.label.sold_out + '</div>' : '';
    itemHtml = itemHtml.replace(/{{soldOutHtml}}/g, soldOutHtml);

    // Add On Sale Tag
    var onSaleHtml = onSale ? '<div class="hide">' + bcSfFilterConfig.label.sale + '</div>' : '';
    itemHtml = itemHtml.replace(/{{onSaleHtml}}/g, onSaleHtml);

    // Add Condition Badge
    var customBadgeHtml =  hasBadge ? '<div class="badge__wrapper badge--' + customBadge + '"></div>' : '';
    itemHtml = itemHtml.replace(/{{customBadgeHtml}}/g, customBadgeHtml);

    // Add Product Link Opening Html
    var linkDisabled = soldOut ? ' grid-product__link--disabled' : '';
    var productLinkOpeningHtml = '<a href="{{itemUrl}}" class="grid-product__link' + linkDisabled + '" data-product-id="' + data.id + '">';
    itemHtml = itemHtml.replace(/{{productLinkOpeningHtml}}/g, productLinkOpeningHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var vendorHtml = bcSfFilterConfig.custom.enable_product_vendor ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{vendorHtml}}/g, vendorHtml);

    // Add Price
    var priceHtml = '';
    if(onSale){
        priceHtml = '<span class="visually-hidden">$' + data.price_max.toFixed(2) + '</span>' +
        '<span class="grid-product__price--original">$' + data.compare_at_price_min.toFixed(2) + '</span>' +
        '<span>$' + data.price_min.toFixed(2) + '</span>'
    } else {
        priceHtml = '$' + data.price_max.toFixed(2);
    }
    itemHtml = itemHtml.replace(/{{priceHtml}}/g, priceHtml);
    // var itemPriceHtml = '';
    // if (data.title != '') {
    //     itemPriceHtml += '<p class="grid-link__meta">';
    //     if (onSale) {
    //         itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> ';
    //     }
    //     if (priceVaries) {
    //         itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
    //     } else {
    //         itemPriceHtml += this.formatMoney(data.price_min);
    //     }
    //     itemPriceHtml += '</p>';
    // }
    // itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    // var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    // itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // // Add onSale class
    // var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    // itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // // Add soldOut Label
    // var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    // itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // // Add onSale Label
    // var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    // itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // // Add Vendor
    // var itemVendorHtml = bcSfFilterConfig.custom.enable_product_vendor ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    // itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // // Add main attribute (Always put at the end of this function)
    // itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    // itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{titleHtml}}/g, '<h2 class="grid-product__title grid-product__title--' + bcSfFilterConfig.custom.type_product_style + '">' + data.title + '</h2>');
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
        totalPage = bcSfFilterConfig.custom.total_pages && bcSfFilterConfig.custom.total_pages < totalPage ? bcSfFilterConfig.custom.total_pages : totalPage;

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
	// Build total products text
	var totalProductText = '';
	if (data.total_product == 1) {
		totalProductText = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
	} else {
		totalProductText = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
	}
	totalProductText = jQ.parseHTML(totalProductText);
	jQ('.bc-sf-filter-total-product').html(totalProductText);
};

BCSfFilter.prototype.changeAddressBar = function (newUrl, eventType, value) {
    // Replace ?_=pf by blank when url does not exist any params of filter
    var tempUrl = '?' + newUrl.split('?')[1];
    var params = tempUrl.substr(1).split('&');
    if (params.length == 1 || this.checkExistFilterOptionParam() === false) {
        if (params.length > 1 && this.checkExistFilterOptionParam() === false) {
            newUrl = newUrl.replace('&_=' + this.prefix, '');
        } else {
            newUrl = newUrl.replace('?_=' + this.prefix, '');
        }
    }
    if (typeof eventType !== 'undefined' && typeof value == 'undefined') {
        var params = this.getFilterParams(newUrl);
        value = params.hasOwnProperty(eventType) ? params[eventType] : '';
    }
    var newTitle = document.title;
    if (typeof eventType !== 'undefined' && typeof value !== 'undefined' && eventType == 'collection' && !this.isSearchPage()) {
        newTitle = this.textify(value) + ' - ' + this.shopName;
    }
    History.pushState({
        param: this.queryParams
    }, newTitle, newUrl);
    this.triggerGoogleAnalytics(newTitle, newUrl, eventType, value);
};

BCSfFilter.prototype.triggerGoogleAnalytics = function (pageTitle, pageUrl, eventType, eventValue) {
    var GOOGLE_ANALYTICS_ID = 'UA-51483457-1';
    if (!window.ga || typeof window.ga != 'function') return;
    switch (eventType) {
        case 'page':
            // Registers a new page view on changing page
            var pagePath = window.location.pathname + '?' + eventType + '=' + eventValue;
            ga('send', {
                hitType: 'pageview',
                page: pagePath
            });
            break;
        case 'collection':
            // Registers a new page view on changing collection
            var pagePath = window.location.pathname;
        ga('send', {
                hitType: 'pageview',
                page: pagePath
            });
            break;
        case 'clearAllFilterOptions':
        case 'clearFilterOptions':
        case 'display':
        case 'limit':
        case 'sort':
        case 'filter':
            // Do nothing on clearing filter, changing display type (grid/list view), changing products per page, changing sort, close/open filter
            break;
        default:
            // Otherwise, registers a new filter event
            var filterOption = eventType.split('_').pop();
            var eventAction = 'Filter by: ' + filterOption;
            var eventLabel = 'Filter by: ' + filterOption + (eventValue ? (' - Value: ' + eventValue) : '');
            ga('send', {
          hitType: 'event',
            eventCategory: 'Boost Product Filter',
            eventAction: eventAction,
            eventLabel: eventLabel
        });
            break;
    }
}

BCSfFilter.prototype.scrollBackPositionHistoryBack = function() {
    // Get setting
    var enableKeepScrollbackPosition = this.getSettingValue('general.enableKeepScrollbackPosition');
    if (enableKeepScrollbackPosition) {
        // Get the product grid item
        var productItemSelector = jQ(this.selector.products).children();
        if (this.isAdvancedPaginationType() && productItemSelector.length > 0) {
            // Get current page
            var page = parseInt(this.queryParams.page);
            // Add id & data-page attribute to item
            productItemSelector.each(function() {
                if (typeof jQ(this).attr('id') == 'undefined') {
                    var itemLink = '';
                    jQ(this).find('a').each(function() {
                        var link = jQ(this).attr('href') || '';
                        if (link.length > 0 && link.match(/(?:\/products\/)(?:[^\?]*)/)) {
                            itemLink = link.split('?')[0];
                            return false;
                        }
                    });
                    var idItem = itemLink.toString().replace(/^_+|_+$|\//g, '') + '-' + page;
                    jQ(this).attr('id', idItem);
                }
                if (typeof jQ(this).data('page') == 'undefined') {
                    jQ(this).attr('data-page', page);
                }
            });
            if (this.isMobile()) {
                // Change params on the address bar when click to item
                var isScrolling = false;
                // Change params on the address bar when click to item ( Ignore if scrolling action )
                productItemSelector.on('touchstart', function() {
                    isScrolling = false;
                }).on('touchmove', function(e) {
                    isScrolling = true;
                }).on('touchend', function(e) {
                    var productId = jQ(this).attr('id') || false;
                    if (!isScrolling && productId) {
                        var urlW = new URL(window.location.href),
                            page = jQ(this).data('page') || 1,
                            stage = {
                                productId: productId,
                                page: page
                            };
                        if (urlW.searchParams.get('page') !== null) urlW.searchParams.delete('page');
                        if (parseInt(page) > 1) urlW.searchParams.append('page', page);
                        // Set state before redirect to product page
                        window.history.replaceState(stage, '', urlW.toString().replace(/\+/g, '%20'));
                    }
                });
            } else {
                // Change params on the address bar when click to item
                productItemSelector.click(function(e) {
                    var productId = jQ(this).attr('id') || false;
                    if (productId) {
                        var urlW = new URL(window.location.href),
                            page = jQ(this).data('page') || 1,
                            stage = {
                                productId: productId,
                                page: page
                            };
                        if (urlW.searchParams.get('page') !== null) urlW.searchParams.delete('page');
                        if (parseInt(page) > 1) urlW.searchParams.append('page', page);
                        // Set state before redirect to product page
                        window.history.replaceState(stage, '', urlW.toString().replace(/\+/g, '%20'));
                    }
                    
                });
            }
            // Turn off scroll default  of browser
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            if (history.state !== null && history.state.hasOwnProperty('productId')) {
                var urlW = new URL(window.location.href),
                    itemId = history.state.productId;
                if (itemId !== null) {
                    window.history.replaceState('', '', urlW.toString().replace(/\+/g, '%20'));
                    jQ('html, body').animate({ scrollTop: jQ('#' + itemId).offset().top - 200 }, 0);
                }
            }
        }
    }
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
